interface ExtractionConfig {
    extraction_timeout: number;
    scan_parent_file: boolean;
    extract_office: boolean;
    max_recursion_level: number;
    max_child_number: number;
    max_archive_size: number;
    encoding_preference: boolean;
    'encoding_preference.automatic_recognition': boolean;
    'encoding_preference.default': string;
    enforce_content_type_matched: boolean;
    extract_on_error: boolean;
    extract_split_archive: boolean;
    'extract_split_archive.file_type': string[];
    extract_task_failed: boolean;
    'extract_task_failed.cli_extraction_errors': boolean;
    'extract_task_failed.contain_unexpected_data': boolean;
    'extract_task_failed.extracted_partially': boolean;
    'extract_task_failed.extraction_other_errors': boolean;
    'extract_task_failed.invalid_file_structure': boolean;
    'extract_task_failed.system_errors': boolean;
    'extract_task_failed.unextractable': boolean;
    'extract_task_failed.unsupported_archive': boolean;
    include_cli_extraction: boolean;
    prioritize_detected_charset: boolean;
    skipped_extraction: boolean;
    'skipped_extraction.default_file_type': string[];
    'skipped_extraction.file_type': string[];
    unsupported_fs_behavior: string;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface AigcdConfig {
    aigcd_timeout: number;
    aigcd_retries: number;
    detect_ai_content: boolean;
    'detect_ai_content.image': boolean;
    'detect_ai_content.image.ai': boolean;
    'detect_ai_content.text': boolean;
    'detect_ai_content.text.ai'?: boolean;
    'detect_ai_content.threshold'?: number;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface CompressionConfig {
    compression_timeout: number;
    skip_encrypted_items: boolean;
    skip_infected_items: boolean;
    compression_conversions: boolean;
    compression_retain_password: boolean;
    'compression_retain_password.zip': boolean;
    'compression_retain_password.7z': boolean;
    'compression_retain_password.rar': boolean;
    'compression_conversions.3dml'?: boolean;
    'compression_conversions.3dml.to'?: string;
    'compression_conversions.7z'?: boolean;
    'compression_conversions.7z.to'?: string;
    'compression_conversions.ace'?: boolean;
    'compression_conversions.ace.to'?: string;
    'compression_conversions.alz'?: boolean;
    'compression_conversions.alz.to'?: string;
    'compression_conversions.arj'?: boolean;
    'compression_conversions.arj.to'?: string;
    'compression_conversions.asar'?: boolean;
    'compression_conversions.asar.to'?: string;
    'compression_conversions.asice'?: boolean;
    'compression_conversions.asice.to'?: string;
    'compression_conversions.asics'?: boolean;
    'compression_conversions.asics.to'?: string;
    'compression_conversions.b3dm'?: boolean;
    'compression_conversions.b3dm.to'?: string;
    'compression_conversions.base64'?: boolean;
    'compression_conversions.base64.to'?: string;
    'compression_conversions.bz2'?: boolean;
    'compression_conversions.bz2.to'?: string;
    'compression_conversions.cab'?: boolean;
    'compression_conversions.cab.to'?: string;
    'compression_conversions.egg'?: boolean;
    'compression_conversions.egg.to'?: string;
    'compression_conversions.eml'?: boolean;
    'compression_conversions.eml.to'?: string;
    'compression_conversions.esz'?: boolean;
    'compression_conversions.esz.to'?: string;
    'compression_conversions.gpkg'?: boolean;
    'compression_conversions.gpkg.to'?: string;
    'compression_conversions.gz'?: boolean;
    'compression_conversions.gz.to'?: string;
    'compression_conversions.lz'?: boolean;
    'compression_conversions.lz.to'?: string;
    'compression_conversions.lzh'?: boolean;
    'compression_conversions.lzh.to'?: string;
    'compression_conversions.lzma'?: boolean;
    'compression_conversions.lzma.to'?: string;
    'compression_conversions.mbx'?: boolean;
    'compression_conversions.mbx.to'?: string;
    'compression_conversions.mdzip'?: boolean;
    'compression_conversions.mdzip.to'?: string;
    'compression_conversions.msg'?: boolean;
    'compression_conversions.msg.to'?: string;
    'compression_conversions.oft'?: boolean;
    'compression_conversions.oft.to'?: string;
    'compression_conversions.pck'?: boolean;
    'compression_conversions.pck.to'?: string;
    'compression_conversions.pst'?: boolean;
    'compression_conversions.pst.to'?: string;
    'compression_conversions.rar'?: boolean;
    'compression_conversions.rar.to'?: string;
    'compression_conversions.ribc'?: boolean;
    'compression_conversions.ribc.to'?: string;
    'compression_conversions.scdoc'?: boolean;
    'compression_conversions.scdoc.to'?: string;
    'compression_conversions.spf'?: boolean;
    'compression_conversions.spf.to'?: string;
    'compression_conversions.story'?: boolean;
    'compression_conversions.story.to'?: string;
    'compression_conversions.tar'?: boolean;
    'compression_conversions.tar.to'?: string;
    'compression_conversions.tnef'?: boolean;
    'compression_conversions.tnef.to'?: string;
    'compression_conversions.tse'?: boolean;
    'compression_conversions.tse.to'?: string;
    'compression_conversions.tsec'?: boolean;
    'compression_conversions.tsec.to'?: string;
    'compression_conversions.tsez'?: boolean;
    'compression_conversions.tsez.to'?: string;
    'compression_conversions.twbx'?: boolean;
    'compression_conversions.twbx.to'?: string;
    'compression_conversions.utib'?: boolean;
    'compression_conversions.utib.to'?: string;
    'compression_conversions.wsp'?: boolean;
    'compression_conversions.wsp.to'?: string;
    'compression_conversions.xz'?: boolean;
    'compression_conversions.xz.to'?: string;
    'compression_conversions.zip'?: boolean;
    'compression_conversions.zip.to'?: string;
    'compression_conversions.zstd'?: boolean;
    'compression_conversions.zstd.to'?: string;
    include_utf8_file_name: boolean;
    preserve_entry_name: boolean;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface CooConfig {
    coo_timeout: number;
    coo_retries: number;
    block_when_coo_failed: boolean;
    block_when_coo_unsupported: boolean;
    scan_after_coo: string[];
    action: string;
    country_filters: boolean;
    'country_filters.include_country_not_detectable': boolean;
    'country_filters.values': string[];
    vendor_filters: boolean;
    'vendor_filters.values': string[];
    verify_digital_certificate: boolean;
    'verify_digital_certificate.trusted_cas_dir': string;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface DlpConfig {
    dlp_timeout: number;
    dlp_retries: number;
    anonymization: boolean;
    'anonymization.dicom': boolean;
    'anonymization.dicom.burnedinannotations': boolean;
    'anonymization.dicom.customlist': string[];
    'anonymization.dicom.privatetags': boolean;
    'anonymization.dicom.skiplist': string[];
    'anonymization.pcap': boolean;
    block_when_prevent_data_leak_failed: boolean;
    crop_embedded_images: boolean;
    detect_encoding: boolean;
    'detect_encoding.fallback': number;
    document_identification: boolean;
    'document_identification.nsfw': boolean;
    'document_identification.nsfw.nsfw_drugs': boolean;
    'document_identification.nsfw.nsfw_politics': boolean;
    'document_identification.nsfw.nsfw_porn': boolean;
    'document_identification.nsfw.nsfw_sexy': boolean;
    'document_identification.nsfw.nsfw_suicide': boolean;
    'document_identification.nsfw.nsfw_toxic_words': boolean;
    'document_identification.nsfw.nsfw_violence': boolean;
    'document_identification.nsfw.nsfw_weapon': boolean;
    'document_identification.nsfw.redact': boolean;
    'document_identification.nsfw.redact.allow': boolean;
    'document_identification.nsfw.redact.level': number;
    'document_identification.personal_document': boolean;
    'document_identification.personal_document.animal': boolean;
    'document_identification.personal_document.default_behaviour': number;
    'document_identification.personal_document.employment': boolean;
    'document_identification.personal_document.financial': boolean;
    'document_identification.personal_document.government': boolean;
    'document_identification.personal_document.personal_id': boolean;
    'document_identification.personal_document.utility': boolean;
    file_size_limit: number;
    intentional_data_leak_detection: boolean;
    'intentional_data_leak_detection.font_size': boolean;
    'intentional_data_leak_detection.font_size.minimum_font_size_threshold': number;
    'intentional_data_leak_detection.invisible_text': boolean;
    metadata_removal: boolean;
    nameformat: string;
    ocr: boolean;
    'ocr.languages': string[];
    'ocr.quality': number;
    scan: boolean;
    'scan.advanced.context': number;
    'scan.advanced.detectionpolicy_v2': boolean;
    'scan.advanced.detectionpolicy_v2.policylist': string[];
    'scan.advanced.globalallowlist': boolean;
    'scan.advanced.globalallowlist.allowlist': string[];
    'scan.advanced.hash_method': string;
    'scan.advanced.hash_repeat': boolean;
    'scan.advanced.interrupt': boolean;
    'scan.advanced.interrupt.hitlimit': number;
    'scan.advanced.limit_result': number;
    'scan.advanced.pdf_remove_alternate_images': boolean;
    'scan.advanced.recursion': boolean;
    'scan.advanced.recursion.depthlimit': number;
    'scan.advanced.recursion.filelimit': number;
    'scan.advanced.recursion.recursive_remove_on_error': boolean;
    'scan.advanced.redact_method': string;
    'scan.advanced.substitution_repeat': boolean;
    'scan.advanced.substitution_text': string;
    'scan.ai': boolean;
    'scan.ai.financial': boolean;
    'scan.ai.financial.advanced.validation': boolean;
    'scan.ai.financial.advanced.validation.beginning': string;
    'scan.ai.financial.advanced.validation.delimiter': string;
    'scan.ai.financial.advanced.validation.ending': string;
    'scan.ai.financial.advanced.validation.prefix': string;
    'scan.ai.financial.advanced.validation.suffix': string;
    'scan.ai.financial.info_types': string[];
    'scan.ai.financial.redact': boolean;
    'scan.ai.financial.redact.allow': boolean;
    'scan.ai.financial.redact.level': number;
    'scan.ai.health': boolean;
    'scan.ai.health.advanced.validation': boolean;
    'scan.ai.health.advanced.validation.beginning': string;
    'scan.ai.health.advanced.validation.delimiter': string;
    'scan.ai.health.advanced.validation.ending': string;
    'scan.ai.health.advanced.validation.prefix': string;
    'scan.ai.health.advanced.validation.suffix': string;
    'scan.ai.health.info_types': string[];
    'scan.ai.health.redact': boolean;
    'scan.ai.health.redact.allow': boolean;
    'scan.ai.health.redact.level': number;
    'scan.ai.pii': boolean;
    'scan.ai.pii.advanced.validation': boolean;
    'scan.ai.pii.advanced.validation.beginning': string;
    'scan.ai.pii.advanced.validation.delimiter': string;
    'scan.ai.pii.advanced.validation.ending': string;
    'scan.ai.pii.advanced.validation.prefix': string;
    'scan.ai.pii.advanced.validation.suffix': string;
    'scan.ai.pii.info_types': string[];
    'scan.ai.pii.redact': boolean;
    'scan.ai.pii.redact.allow': boolean;
    'scan.ai.pii.redact.level': number;
    'scan.ai.transport': boolean;
    'scan.ai.transport.advanced.validation': boolean;
    'scan.ai.transport.advanced.validation.beginning': string;
    'scan.ai.transport.advanced.validation.delimiter': string;
    'scan.ai.transport.advanced.validation.ending': string;
    'scan.ai.transport.advanced.validation.prefix': string;
    'scan.ai.transport.advanced.validation.suffix': string;
    'scan.ai.transport.info_types': string[];
    'scan.ai.transport.redact': boolean;
    'scan.ai.transport.redact.allow': boolean;
    'scan.ai.transport.redact.level': number;
    'scan.certainty_threshold': number;
    'scan.corporate': boolean;
    'scan.corporate.business_reg_num': boolean;
    'scan.corporate.business_reg_num.advanced.custom_keywords': string;
    'scan.corporate.business_reg_num.advanced.default_keywords': boolean;
    'scan.corporate.business_reg_num.advanced.validation': boolean;
    'scan.corporate.business_reg_num.advanced.validation.beginning': string;
    'scan.corporate.business_reg_num.advanced.validation.delimiter': string;
    'scan.corporate.business_reg_num.advanced.validation.ending': string;
    'scan.corporate.business_reg_num.advanced.validation.prefix': string;
    'scan.corporate.business_reg_num.advanced.validation.suffix': string;
    'scan.corporate.business_reg_num.info_types': string[];
    'scan.corporate.business_reg_num.redact': boolean;
    'scan.corporate.business_reg_num.redact.allow': boolean;
    'scan.corporate.business_reg_num.redact.level': number;
    'scan.financial': boolean;
    'scan.financial.aba_routing_number': boolean;
    'scan.financial.aba_routing_number.advanced.custom_keywords': string;
    'scan.financial.aba_routing_number.advanced.default_keywords': boolean;
    'scan.financial.aba_routing_number.advanced.validation': boolean;
    'scan.financial.aba_routing_number.advanced.validation.beginning': string;
    'scan.financial.aba_routing_number.advanced.validation.delimiter': string;
    'scan.financial.aba_routing_number.advanced.validation.ending': string;
    'scan.financial.aba_routing_number.advanced.validation.prefix': string;
    'scan.financial.aba_routing_number.advanced.validation.suffix': string;
    'scan.financial.aba_routing_number.redact': boolean;
    'scan.financial.aba_routing_number.redact.allow': boolean;
    'scan.financial.aba_routing_number.redact.level': number;
    'scan.financial.ccn': boolean;
    'scan.financial.ccn.advanced.custom_keywords': string;
    'scan.financial.ccn.advanced.default_keywords': boolean;
    'scan.financial.ccn.advanced.validation': boolean;
    'scan.financial.ccn.advanced.validation.beginning': string;
    'scan.financial.ccn.advanced.validation.delimiter': string;
    'scan.financial.ccn.advanced.validation.ending': string;
    'scan.financial.ccn.advanced.validation.prefix': string;
    'scan.financial.ccn.advanced.validation.suffix': string;
    'scan.financial.ccn.redact': boolean;
    'scan.financial.ccn.redact.allow': boolean;
    'scan.financial.ccn.redact.level': number;
    'scan.financial.iban': boolean;
    'scan.financial.iban.advanced.custom_keywords': string;
    'scan.financial.iban.advanced.default_keywords': boolean;
    'scan.financial.iban.advanced.validation': boolean;
    'scan.financial.iban.advanced.validation.beginning': string;
    'scan.financial.iban.advanced.validation.delimiter': string;
    'scan.financial.iban.advanced.validation.ending': string;
    'scan.financial.iban.advanced.validation.prefix': string;
    'scan.financial.iban.advanced.validation.suffix': string;
    'scan.financial.iban.redact': boolean;
    'scan.financial.iban.redact.allow': boolean;
    'scan.financial.iban.redact.level': number;
    'scan.financial.isin': boolean;
    'scan.financial.isin.advanced.custom_keywords': string;
    'scan.financial.isin.advanced.default_keywords': boolean;
    'scan.financial.isin.advanced.validation': boolean;
    'scan.financial.isin.advanced.validation.beginning': string;
    'scan.financial.isin.advanced.validation.delimiter': string;
    'scan.financial.isin.advanced.validation.ending': string;
    'scan.financial.isin.advanced.validation.prefix': string;
    'scan.financial.isin.advanced.validation.suffix': string;
    'scan.financial.isin.redact': boolean;
    'scan.financial.isin.redact.allow': boolean;
    'scan.financial.isin.redact.level': number;
    'scan.financial.swift_code': boolean;
    'scan.financial.swift_code.advanced.custom_keywords': string;
    'scan.financial.swift_code.advanced.default_keywords': boolean;
    'scan.financial.swift_code.advanced.validation': boolean;
    'scan.financial.swift_code.advanced.validation.beginning': string;
    'scan.financial.swift_code.advanced.validation.delimiter': string;
    'scan.financial.swift_code.advanced.validation.ending': string;
    'scan.financial.swift_code.advanced.validation.prefix': string;
    'scan.financial.swift_code.advanced.validation.suffix': string;
    'scan.financial.swift_code.redact': boolean;
    'scan.financial.swift_code.redact.allow': boolean;
    'scan.financial.swift_code.redact.level': number;
    'scan.financial.us_bank_account': boolean;
    'scan.financial.us_bank_account.advanced.custom_keywords': string;
    'scan.financial.us_bank_account.advanced.default_keywords': boolean;
    'scan.financial.us_bank_account.advanced.validation': boolean;
    'scan.financial.us_bank_account.advanced.validation.beginning': string;
    'scan.financial.us_bank_account.advanced.validation.delimiter': string;
    'scan.financial.us_bank_account.advanced.validation.ending': string;
    'scan.financial.us_bank_account.advanced.validation.prefix': string;
    'scan.financial.us_bank_account.advanced.validation.suffix': string;
    'scan.financial.us_bank_account.redact': boolean;
    'scan.financial.us_bank_account.redact.allow': boolean;
    'scan.financial.us_bank_account.redact.level': number;
    'scan.health': boolean;
    'scan.health.health_service_num': boolean;
    'scan.health.health_service_num.advanced.custom_keywords': string;
    'scan.health.health_service_num.advanced.default_keywords': boolean;
    'scan.health.health_service_num.advanced.validation': boolean;
    'scan.health.health_service_num.advanced.validation.beginning': string;
    'scan.health.health_service_num.advanced.validation.delimiter': string;
    'scan.health.health_service_num.advanced.validation.ending': string;
    'scan.health.health_service_num.advanced.validation.prefix': string;
    'scan.health.health_service_num.advanced.validation.suffix': string;
    'scan.health.health_service_num.info_types': string[];
    'scan.health.health_service_num.redact': boolean;
    'scan.health.health_service_num.redact.allow': boolean;
    'scan.health.health_service_num.redact.level': number;
    'scan.health.icd': boolean;
    'scan.health.icd.advanced.custom_keywords': string;
    'scan.health.icd.advanced.default_keywords': boolean;
    'scan.health.icd.advanced.validation': boolean;
    'scan.health.icd.advanced.validation.beginning': string;
    'scan.health.icd.advanced.validation.delimiter': string;
    'scan.health.icd.advanced.validation.ending': string;
    'scan.health.icd.advanced.validation.prefix': string;
    'scan.health.icd.advanced.validation.suffix': string;
    'scan.health.icd.info_types': string[];
    'scan.health.icd.redact': boolean;
    'scan.health.icd.redact.allow': boolean;
    'scan.health.icd.redact.level': number;
    'scan.legal_compliance': boolean;
    'scan.legal_compliance.ai': boolean;
    'scan.legal_compliance.categories': string[];
    'scan.legal_compliance.redact': boolean;
    'scan.legal_compliance.redact.allow': boolean;
    'scan.legal_compliance.redact.level': number;
    'scan.metadata': boolean;
    'scan.metadata.custom_regex_file': boolean;
    'scan.metadata.custom_regex_file.paths': string[];
    'scan.metadata.metadatalist': string[];
    'scan.network': boolean;
    'scan.network.cidr': boolean;
    'scan.network.cidr.advanced.custom_keywords': string;
    'scan.network.cidr.advanced.default_keywords': boolean;
    'scan.network.cidr.advanced.validation': boolean;
    'scan.network.cidr.advanced.validation.beginning': string;
    'scan.network.cidr.advanced.validation.delimiter': string;
    'scan.network.cidr.advanced.validation.ending': string;
    'scan.network.cidr.advanced.validation.prefix': string;
    'scan.network.cidr.advanced.validation.suffix': string;
    'scan.network.cidr.redact': boolean;
    'scan.network.cidr.redact.allow': boolean;
    'scan.network.cidr.redact.level': number;
    'scan.network.imei_number': boolean;
    'scan.network.imei_number.advanced.custom_keywords': string;
    'scan.network.imei_number.advanced.default_keywords': boolean;
    'scan.network.imei_number.advanced.validation': boolean;
    'scan.network.imei_number.advanced.validation.beginning': string;
    'scan.network.imei_number.advanced.validation.delimiter': string;
    'scan.network.imei_number.advanced.validation.ending': string;
    'scan.network.imei_number.advanced.validation.prefix': string;
    'scan.network.imei_number.advanced.validation.suffix': string;
    'scan.network.imei_number.redact': boolean;
    'scan.network.imei_number.redact.allow': boolean;
    'scan.network.imei_number.redact.level': number;
    'scan.network.ipv4': boolean;
    'scan.network.ipv4.advanced.custom_keywords': string;
    'scan.network.ipv4.advanced.default_keywords': boolean;
    'scan.network.ipv4.advanced.validation': boolean;
    'scan.network.ipv4.advanced.validation.beginning': string;
    'scan.network.ipv4.advanced.validation.delimiter': string;
    'scan.network.ipv4.advanced.validation.ending': string;
    'scan.network.ipv4.advanced.validation.prefix': string;
    'scan.network.ipv4.advanced.validation.suffix': string;
    'scan.network.ipv4.redact': boolean;
    'scan.network.ipv4.redact.allow': boolean;
    'scan.network.ipv4.redact.level': number;
    'scan.pii': boolean;
    'scan.pii.passport': boolean;
    'scan.pii.passport.advanced.custom_keywords': string;
    'scan.pii.passport.advanced.default_keywords': boolean;
    'scan.pii.passport.advanced.validation': boolean;
    'scan.pii.passport.advanced.validation.beginning': string;
    'scan.pii.passport.advanced.validation.delimiter': string;
    'scan.pii.passport.advanced.validation.ending': string;
    'scan.pii.passport.advanced.validation.prefix': string;
    'scan.pii.passport.advanced.validation.suffix': string;
    'scan.pii.passport.info_types': string[];
    'scan.pii.passport.redact': boolean;
    'scan.pii.passport.redact.allow': boolean;
    'scan.pii.passport.redact.level': number;
    'scan.pii.phone_number': boolean;
    'scan.pii.phone_number.advanced.custom_keywords': string;
    'scan.pii.phone_number.advanced.default_keywords': boolean;
    'scan.pii.phone_number.advanced.validation': boolean;
    'scan.pii.phone_number.advanced.validation.beginning': string;
    'scan.pii.phone_number.advanced.validation.delimiter': string;
    'scan.pii.phone_number.advanced.validation.ending': string;
    'scan.pii.phone_number.advanced.validation.prefix': string;
    'scan.pii.phone_number.advanced.validation.suffix': string;
    'scan.pii.phone_number.info_types': string[];
    'scan.pii.phone_number.redact': boolean;
    'scan.pii.phone_number.redact.allow': boolean;
    'scan.pii.phone_number.redact.level': number;
    'scan.pii.ssn': boolean;
    'scan.pii.ssn.advanced.custom_keywords': string;
    'scan.pii.ssn.advanced.default_keywords': boolean;
    'scan.pii.ssn.advanced.validation': boolean;
    'scan.pii.ssn.advanced.validation.beginning': string;
    'scan.pii.ssn.advanced.validation.delimiter': string;
    'scan.pii.ssn.advanced.validation.ending': string;
    'scan.pii.ssn.advanced.validation.prefix': string;
    'scan.pii.ssn.advanced.validation.suffix': string;
    'scan.pii.ssn.info_types': string[];
    'scan.pii.ssn.redact': boolean;
    'scan.pii.ssn.redact.allow': boolean;
    'scan.pii.ssn.redact.level': number;
    'scan.pii.tin': boolean;
    'scan.pii.tin.advanced.custom_keywords': string;
    'scan.pii.tin.advanced.default_keywords': boolean;
    'scan.pii.tin.advanced.validation': boolean;
    'scan.pii.tin.advanced.validation.beginning': string;
    'scan.pii.tin.advanced.validation.delimiter': string;
    'scan.pii.tin.advanced.validation.ending': string;
    'scan.pii.tin.advanced.validation.prefix': string;
    'scan.pii.tin.advanced.validation.suffix': string;
    'scan.pii.tin.info_types': string[];
    'scan.pii.tin.redact': boolean;
    'scan.pii.tin.redact.allow': boolean;
    'scan.pii.tin.redact.level': number;
    'scan.regex': boolean;
    'scan.regex.custom_regex_file': boolean;
    'scan.regex.custom_regex_file.paths': string[];
    'scan.regex.regexlist': string[];
    'scan.secret': boolean;
    'scan.secret.cloud': boolean;
    'scan.secret.cloud.list': number[];
    'scan.secret.db': boolean;
    'scan.secret.db.list': number[];
    'scan.secret.generic': boolean;
    'scan.secret.generic.list': number[];
    tagging: boolean;
    timeout: number;
    watermark: boolean;
    'watermark.fontsize': number;
    'watermark.mandatory': boolean;
    'watermark.opacity': number;
    'watermark.position': number;
    'watermark.text': string;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface CdrConfig {
    cdr_timeout: number;
    cdr_retries: number;
    block_unsupported_file: boolean;
    enable_extraction: boolean;
    include_blocked_sanitization: boolean;
    rescan_sanitize_file: boolean;
    preserve_entry_name: boolean;
    add_tombstone: boolean;
    enable_partial_sanitization: boolean;
    block_when_sanitize_failed: boolean;
    retain_password: boolean;
    conversions: boolean;
    sanitized_naming_pattern: string;
    'retain_password.doc'?: boolean;
    'retain_password.docm'?: boolean;
    'retain_password.docx'?: boolean;
    'retain_password.dot'?: boolean;
    'retain_password.dotm'?: boolean;
    'retain_password.dotx'?: boolean;
    'retain_password.pdf'?: boolean;
    'retain_password.ppt'?: boolean;
    'retain_password.pptx'?: boolean;
    'retain_password.xls'?: boolean;
    'retain_password.xlsb'?: boolean;
    'retain_password.xlsm'?: boolean;
    'retain_password.xlsx'?: boolean;
    'retain_password.xlt'?: boolean;
    'retain_password.xltm'?: boolean;
    'retain_password.xltx'?: boolean;
    'conversions.3ds'?: boolean;
    'conversions.3ds.to'?: string;
    'conversions.3gp'?: boolean;
    'conversions.3gp.to'?: string;
    'conversions.aac'?: boolean;
    'conversions.aac.to'?: string;
    'conversions.acm'?: boolean;
    'conversions.acm.to'?: string;
    'conversions.aem'?: boolean;
    'conversions.aem.to'?: string;
    'conversions.ai'?: boolean;
    'conversions.ai.to'?: string;
    'conversions.aiff'?: boolean;
    'conversions.aiff.to'?: string;
    'conversions.ait'?: boolean;
    'conversions.ait.to'?: string;
    'conversions.apng'?: boolean;
    'conversions.apng.to'?: string;
    'conversions.avi'?: boolean;
    'conversions.avi.to'?: string;
    'conversions.avif'?: boolean;
    'conversions.avif.to'?: string;
    'conversions.bfo'?: boolean;
    'conversions.bfo.to'?: string;
    'conversions.bml'?: boolean;
    'conversions.bml.to'?: string;
    'conversions.bmp'?: boolean;
    'conversions.bmp.to'?: string;
    'conversions.bw64'?: boolean;
    'conversions.bw64.to'?: string;
    'conversions.bwf'?: boolean;
    'conversions.bwf.to'?: string;
    'conversions.caf'?: boolean;
    'conversions.caf.to'?: string;
    'conversions.cell'?: boolean;
    'conversions.cell.to'?: string;
    'conversions.crl'?: boolean;
    'conversions.crl.to'?: string;
    'conversions.csv'?: boolean;
    'conversions.csv.to'?: string;
    'conversions.cur'?: boolean;
    'conversions.cur.to'?: string;
    'conversions.dae'?: boolean;
    'conversions.dae.to'?: string;
    'conversions.dbf'?: boolean;
    'conversions.dbf.to'?: string;
    'conversions.dcm'?: boolean;
    'conversions.dcm.to'?: string;
    'conversions.doc'?: boolean;
    'conversions.doc.to'?: string;
    'conversions.docm'?: boolean;
    'conversions.docm.to'?: string;
    'conversions.docx'?: boolean;
    'conversions.docx.to'?: string;
    'conversions.dot'?: boolean;
    'conversions.dot.to'?: string;
    'conversions.dotm'?: boolean;
    'conversions.dotm.to'?: string;
    'conversions.dotx'?: boolean;
    'conversions.dotx.to'?: string;
    'conversions.drc'?: boolean;
    'conversions.drc.to'?: string;
    'conversions.dwf'?: boolean;
    'conversions.dwf.to'?: string;
    'conversions.dwfx'?: boolean;
    'conversions.dwfx.to'?: string;
    'conversions.dwg'?: boolean;
    'conversions.dwg.to'?: string;
    'conversions.dws'?: boolean;
    'conversions.dws.to'?: string;
    'conversions.dwt'?: boolean;
    'conversions.dwt.to'?: string;
    'conversions.dxf'?: boolean;
    'conversions.dxf.to'?: string;
    'conversions.easm'?: boolean;
    'conversions.easm.to'?: string;
    'conversions.emf'?: boolean;
    'conversions.emf.to'?: string;
    'conversions.emz'?: boolean;
    'conversions.emz.to'?: string;
    'conversions.fla'?: boolean;
    'conversions.fla.to'?: string;
    'conversions.flv'?: boolean;
    'conversions.flv.to'?: string;
    'conversions.gif'?: boolean;
    'conversions.gif.to'?: string;
    'conversions.har'?: boolean;
    'conversions.har.to'?: string;
    'conversions.heic'?: boolean;
    'conversions.heic.to'?: string;
    'conversions.heif'?: boolean;
    'conversions.heif.to'?: string;
    'conversions.hevc'?: boolean;
    'conversions.hevc.to'?: string;
    'conversions.hta'?: boolean;
    'conversions.hta.to'?: string;
    'conversions.html'?: boolean;
    'conversions.html.to'?: string;
    'conversions.hwp'?: boolean;
    'conversions.hwp.to'?: string;
    'conversions.hwpx'?: boolean;
    'conversions.hwpx.to'?: string;
    'conversions.hwt'?: boolean;
    'conversions.hwt.to'?: string;
    'conversions.ico'?: boolean;
    'conversions.ico.to'?: string;
    'conversions.ics'?: boolean;
    'conversions.ics.to'?: string;
    'conversions.jhd'?: boolean;
    'conversions.jhd.to'?: string;
    'conversions.jnlp'?: boolean;
    'conversions.jnlp.to'?: string;
    'conversions.jpg'?: boolean;
    'conversions.jpg.to'?: string;
    'conversions.jpx'?: boolean;
    'conversions.jpx.to'?: string;
    'conversions.json'?: boolean;
    'conversions.json.to'?: string;
    'conversions.jtd'?: boolean;
    'conversions.jtd.to'?: string;
    'conversions.jtdc'?: boolean;
    'conversions.jtdc.to'?: string;
    'conversions.jwc'?: boolean;
    'conversions.jwc.to'?: string;
    'conversions.jww'?: boolean;
    'conversions.jww.to'?: string;
    'conversions.lnk'?: boolean;
    'conversions.lnk.to'?: string;
    'conversions.log'?: boolean;
    'conversions.log.to'?: string;
    'conversions.m2ts'?: boolean;
    'conversions.m2ts.to'?: string;
    'conversions.m4a'?: boolean;
    'conversions.m4a.to'?: string;
    'conversions.m4v'?: boolean;
    'conversions.m4v.to'?: string;
    'conversions.mht'?: boolean;
    'conversions.mht.to'?: string;
    'conversions.mj2'?: boolean;
    'conversions.mj2.to'?: string;
    'conversions.mkv'?: boolean;
    'conversions.mkv.to'?: string;
    'conversions.mng'?: boolean;
    'conversions.mng.to'?: string;
    'conversions.mov'?: boolean;
    'conversions.mov.to'?: string;
    'conversions.mp3'?: boolean;
    'conversions.mp3.to'?: string;
    'conversions.mp4'?: boolean;
    'conversions.mp4.to'?: string;
    'conversions.mpc'?: boolean;
    'conversions.mpc.to'?: string;
    'conversions.mpd'?: boolean;
    'conversions.mpd.to'?: string;
    'conversions.mpeg'?: boolean;
    'conversions.mpeg.to'?: string;
    'conversions.mpp'?: boolean;
    'conversions.mpp.to'?: string;
    'conversions.mts'?: boolean;
    'conversions.mts.to'?: string;
    'conversions.mxf'?: boolean;
    'conversions.mxf.to'?: string;
    'conversions.nef'?: boolean;
    'conversions.nef.to'?: string;
    'conversions.nrbf'?: boolean;
    'conversions.nrbf.to'?: string;
    'conversions.odg'?: boolean;
    'conversions.odg.to'?: string;
    'conversions.odp'?: boolean;
    'conversions.odp.to'?: string;
    'conversions.ods'?: boolean;
    'conversions.ods.to'?: string;
    'conversions.odt'?: boolean;
    'conversions.odt.to'?: string;
    'conversions.ogg'?: boolean;
    'conversions.ogg.to'?: string;
    'conversions.one'?: boolean;
    'conversions.one.to'?: string;
    'conversions.opus'?: boolean;
    'conversions.opus.to'?: string;
    'conversions.otp'?: boolean;
    'conversions.otp.to'?: string;
    'conversions.ots'?: boolean;
    'conversions.ots.to'?: string;
    'conversions.ott'?: boolean;
    'conversions.ott.to'?: string;
    'conversions.p21'?: boolean;
    'conversions.p21.to'?: string;
    'conversions.paf'?: boolean;
    'conversions.paf.to'?: string;
    'conversions.pbix'?: boolean;
    'conversions.pbix.to'?: string;
    'conversions.pdf'?: boolean;
    'conversions.pdf.to'?: string;
    'conversions.png'?: boolean;
    'conversions.png.to'?: string;
    'conversions.pot'?: boolean;
    'conversions.pot.to'?: string;
    'conversions.potm'?: boolean;
    'conversions.potm.to'?: string;
    'conversions.potx'?: boolean;
    'conversions.potx.to'?: string;
    'conversions.ppam'?: boolean;
    'conversions.ppam.to'?: string;
    'conversions.pps'?: boolean;
    'conversions.pps.to'?: string;
    'conversions.ppsm'?: boolean;
    'conversions.ppsm.to'?: string;
    'conversions.ppsx'?: boolean;
    'conversions.ppsx.to'?: string;
    'conversions.ppt'?: boolean;
    'conversions.ppt.to'?: string;
    'conversions.pptm'?: boolean;
    'conversions.pptm.to'?: string;
    'conversions.pptx'?: boolean;
    'conversions.pptx.to'?: string;
    'conversions.prn'?: boolean;
    'conversions.prn.to'?: string;
    'conversions.rdf'?: boolean;
    'conversions.rdf.to'?: string;
    'conversions.rf64'?: boolean;
    'conversions.rf64.to'?: string;
    'conversions.ribcd'?: boolean;
    'conversions.ribcd.to'?: string;
    'conversions.rtf'?: boolean;
    'conversions.rtf.to'?: string;
    'conversions.rvm'?: boolean;
    'conversions.rvm.to'?: string;
    'conversions.sfc'?: boolean;
    'conversions.sfc.to'?: string;
    'conversions.show'?: boolean;
    'conversions.show.to'?: string;
    'conversions.shp'?: boolean;
    'conversions.shp.to'?: string;
    'conversions.shx'?: boolean;
    'conversions.shx.to'?: string;
    'conversions.sldm'?: boolean;
    'conversions.sldm.to'?: string;
    'conversions.sldx'?: boolean;
    'conversions.sldx.to'?: string;
    'conversions.stp'?: boolean;
    'conversions.stp.to'?: string;
    'conversions.svg'?: boolean;
    'conversions.svg.to'?: string;
    'conversions.swf'?: boolean;
    'conversions.swf.to'?: string;
    'conversions.tds'?: boolean;
    'conversions.tds.to'?: string;
    'conversions.tga'?: boolean;
    'conversions.tga.to'?: string;
    'conversions.tiff'?: boolean;
    'conversions.tiff.to'?: string;
    'conversions.tiff64'?: boolean;
    'conversions.tiff64.to'?: string;
    'conversions.tsv'?: boolean;
    'conversions.tsv.to'?: string;
    'conversions.ttml'?: boolean;
    'conversions.ttml.to'?: string;
    'conversions.twb'?: boolean;
    'conversions.twb.to'?: string;
    'conversions.txt'?: boolean;
    'conversions.txt.to'?: string;
    'conversions.u3d'?: boolean;
    'conversions.u3d.to'?: string;
    'conversions.url'?: boolean;
    'conversions.url.to'?: string;
    'conversions.vcf'?: boolean;
    'conversions.vcf.to'?: string;
    'conversions.vcs'?: boolean;
    'conversions.vcs.to'?: string;
    'conversions.vdx'?: boolean;
    'conversions.vdx.to'?: string;
    'conversions.vsd'?: boolean;
    'conversions.vsd.to'?: string;
    'conversions.vsdm'?: boolean;
    'conversions.vsdm.to'?: string;
    'conversions.vsdx'?: boolean;
    'conversions.vsdx.to'?: string;
    'conversions.vsix'?: boolean;
    'conversions.vsix.to'?: string;
    'conversions.vssm'?: boolean;
    'conversions.vssm.to'?: string;
    'conversions.vssx'?: boolean;
    'conversions.vssx.to'?: string;
    'conversions.vstm'?: boolean;
    'conversions.vstm.to'?: string;
    'conversions.vstx'?: boolean;
    'conversions.vstx.to'?: string;
    'conversions.vsx'?: boolean;
    'conversions.vsx.to'?: string;
    'conversions.vtx'?: boolean;
    'conversions.vtx.to'?: string;
    'conversions.vtxt'?: boolean;
    'conversions.vtxt.to'?: string;
    'conversions.w64'?: boolean;
    'conversions.w64.to'?: string;
    'conversions.wav'?: boolean;
    'conversions.wav.to'?: string;
    'conversions.wdp'?: boolean;
    'conversions.wdp.to'?: string;
    'conversions.webm'?: boolean;
    'conversions.webm.to'?: string;
    'conversions.webp'?: boolean;
    'conversions.webp.to'?: string;
    'conversions.wma'?: boolean;
    'conversions.wma.to'?: string;
    'conversions.wmf'?: boolean;
    'conversions.wmf.to'?: string;
    'conversions.wmv'?: boolean;
    'conversions.wmv.to'?: string;
    'conversions.wsq'?: boolean;
    'conversions.wsq.to'?: string;
    'conversions.xlam'?: boolean;
    'conversions.xlam.to'?: string;
    'conversions.xls'?: boolean;
    'conversions.xls.to'?: string;
    'conversions.xlsb'?: boolean;
    'conversions.xlsb.to'?: string;
    'conversions.xlsm'?: boolean;
    'conversions.xlsm.to'?: string;
    'conversions.xlsx'?: boolean;
    'conversions.xlsx.to'?: string;
    'conversions.xlt'?: boolean;
    'conversions.xlt.to'?: string;
    'conversions.xltm'?: boolean;
    'conversions.xltm.to'?: string;
    'conversions.xltx'?: boolean;
    'conversions.xltx.to'?: string;
    'conversions.xml'?: boolean;
    'conversions.xml.to'?: string;
    'conversions.xml-doc'?: boolean;
    'conversions.xml-doc.to'?: string;
    'conversions.xml-docx'?: boolean;
    'conversions.xml-docx.to'?: string;
    'conversions.xml-pptx'?: boolean;
    'conversions.xml-pptx.to'?: string;
    'conversions.xml-xls'?: boolean;
    'conversions.xml-xls.to'?: string;
    'conversions.xps'?: boolean;
    'conversions.xps.to'?: string;
    'conversions.zei'?: boolean;
    'conversions.zei.to'?: string;
    'advanced_setting.aac2aac'?: boolean;
    'advanced_setting.aac2aac.strict_validation'?: boolean;
    'advanced_setting.aiff2aiff'?: boolean;
    'advanced_setting.aiff2aiff.remove_metadata'?: boolean;
    'advanced_setting.block_file'?: boolean;
    'advanced_setting.block_file.advanced_rule'?: boolean;
    'advanced_setting.block_file.advanced_rule.conditions'?: any[];
    'advanced_setting.block_file.embedded_objects'?: boolean;
    'advanced_setting.block_file.embedded_objects.file_families'?: string[];
    'advanced_setting.block_file.external_content'?: boolean;
    'advanced_setting.block_file.external_content.file_families'?: string[];
    'advanced_setting.block_file.formula'?: boolean;
    'advanced_setting.block_file.formula.file_families'?: string[];
    'advanced_setting.block_file.formula_hyperlink'?: boolean;
    'advanced_setting.block_file.formula_hyperlink.file_families'?: string[];
    'advanced_setting.block_file.hyperlink'?: boolean;
    'advanced_setting.block_file.hyperlink.file_families'?: string[];
    'advanced_setting.block_file.invalid_file_structure'?: boolean;
    'advanced_setting.block_file.invalid_signature'?: boolean;
    'advanced_setting.block_file.invalid_signature.file_families'?: string[];
    'advanced_setting.block_file.other_risks'?: boolean;
    'advanced_setting.block_file.other_risks.file_families'?: string[];
    'advanced_setting.block_file.qr_code'?: boolean;
    'advanced_setting.block_file.qr_code.file_families'?: string[];
    'advanced_setting.block_file.script_objects'?: boolean;
    'advanced_setting.block_file.script_objects.file_families'?: string[];
    'advanced_setting.block_file.suspicious_objects'?: boolean;
    'advanced_setting.block_file.suspicious_objects.file_families'?: string[];
    'advanced_setting.cell2cell'?: boolean;
    'advanced_setting.cell2cell.hyperlink_prefix'?: string;
    'advanced_setting.cell2cell.macro_hash'?: string[];
    'advanced_setting.cell2cell.process_image'?: boolean;
    'advanced_setting.cell2cell.process_image.allowlist_external_image'?: boolean;
    'advanced_setting.cell2cell.process_image.allowlist_pattern'?: string[];
    'advanced_setting.cell2cell.process_image.sanitize_qrcode'?: boolean;
    'advanced_setting.cell2cell.recursive_level'?: number;
    'advanced_setting.cell2cell.remove_comment'?: boolean;
    'advanced_setting.cell2cell.remove_embedded_object'?: boolean;
    'advanced_setting.cell2cell.remove_hyperlink'?: string;
    'advanced_setting.cell2cell.remove_macro'?: string;
    'advanced_setting.cell2cell.remove_metadata'?: boolean;
    'advanced_setting.cell2cell.remove_revision'?: boolean;
    'advanced_setting.csv2csv'?: boolean;
    'advanced_setting.csv2csv.process_formula'?: string;
    'advanced_setting.doc*2doc*'?: boolean;
    'advanced_setting.doc*2doc*.cleanup_unused_resources'?: boolean;
    'advanced_setting.doc*2doc*.convert_to_rasterized_pdf'?: boolean;
    'advanced_setting.doc*2doc*.excluded_file_types_for_recursion'?: string[];
    'advanced_setting.doc*2doc*.hyperlink_prefix'?: string;
    'advanced_setting.doc*2doc*.macro_hash'?: string[];
    'advanced_setting.doc*2doc*.process_ascii_qr'?: boolean;
    'advanced_setting.doc*2doc*.process_image'?: boolean;
    'advanced_setting.doc*2doc*.process_image.allowlist_external_image'?: boolean;
    'advanced_setting.doc*2doc*.process_image.allowlist_pattern'?: string[];
    'advanced_setting.doc*2doc*.process_image.sanitize_qrcode'?: boolean;
    'advanced_setting.doc*2doc*.recursive_level'?: number;
    'advanced_setting.doc*2doc*.remove_chart'?: boolean;
    'advanced_setting.doc*2doc*.remove_comment'?: boolean;
    'advanced_setting.doc*2doc*.remove_custom_xml'?: boolean;
    'advanced_setting.doc*2doc*.remove_embedded_font'?: boolean;
    'advanced_setting.doc*2doc*.remove_embedded_object'?: boolean;
    'advanced_setting.doc*2doc*.remove_hidden_text'?: boolean;
    'advanced_setting.doc*2doc*.remove_hyperlink'?: string;
    'advanced_setting.doc*2doc*.remove_macro'?: string;
    'advanced_setting.doc*2doc*.remove_metadata'?: boolean;
    'advanced_setting.doc*2doc*.remove_revision'?: boolean;
    'advanced_setting.doc*2doc*.remove_smart_tag'?: boolean;
    'advanced_setting.doc*2doc*.skip_signed_file'?: boolean;
    'advanced_setting.doc*2doc*.skip_signed_macro'?: boolean;
    'advanced_setting.doc*2doc*.validate_document_properties'?: boolean;
    'advanced_setting.doc*2doc*.validate_document_properties.validation_effect'?: string;
    'advanced_setting.doc*2doc*.validate_header_footer'?: boolean;
    'advanced_setting.doc*2doc*.validate_header_footer.validation_effect'?: string;
    'advanced_setting.doc*2doc*.validate_structural_xml'?: boolean;
    'advanced_setting.doc*2doc*.validate_structural_xml.validation_effect'?: string;
    'advanced_setting.doc*2doc*.validate_template_name'?: boolean;
    'advanced_setting.doc*2doc*.validate_template_name.validation_effect'?: string;
    'advanced_setting.doc*2doc*.validate_zip_structure'?: boolean;
    'advanced_setting.doc*2doc*.validate_zip_structure.validation_effect'?: string;
    'advanced_setting.dwf2dwf'?: boolean;
    'advanced_setting.dwf2dwf.hyperlink_prefix'?: string;
    'advanced_setting.dwf2dwf.process_hyperlink_behavior'?: string;
    'advanced_setting.dwf2dwf.process_image'?: boolean;
    'advanced_setting.dwf2dwf.remove_embedded_font'?: boolean;
    'advanced_setting.dwg2dwg'?: boolean;
    'advanced_setting.dwg2dwg.remove_macro'?: boolean;
    'advanced_setting.flv2flv'?: boolean;
    'advanced_setting.flv2flv.remove_metadata'?: boolean;
    'advanced_setting.hta2hta'?: boolean;
    'advanced_setting.hta2hta.accept_multiple_html_tags'?: boolean;
    'advanced_setting.hta2hta.hyperlink_prefix'?: string;
    'advanced_setting.hta2hta.hyperlinks_replaced_by'?: string;
    'advanced_setting.hta2hta.process_embedded_image'?: boolean;
    'advanced_setting.hta2hta.process_form'?: boolean;
    'advanced_setting.hta2hta.process_hyperlink_behavior'?: string;
    'advanced_setting.hta2hta.process_image'?: boolean;
    'advanced_setting.hta2hta.process_script'?: string;
    'advanced_setting.hta2hta.process_zero_font_text'?: boolean;
    'advanced_setting.hta2hta.remove_applet'?: boolean;
    'advanced_setting.hta2hta.remove_comment'?: boolean;
    'advanced_setting.hta2hta.remove_iframe'?: boolean;
    'advanced_setting.hta2hta.remove_object'?: boolean;
    'advanced_setting.html2html'?: boolean;
    'advanced_setting.html2html.accept_multiple_html_tags'?: boolean;
    'advanced_setting.html2html.accept_multiple_html_tags.include_documents_without_html_tag'?: boolean;
    'advanced_setting.html2html.hyperlink_prefix'?: string;
    'advanced_setting.html2html.hyperlinks_replaced_by'?: string;
    'advanced_setting.html2html.prefer_pretty_print'?: boolean;
    'advanced_setting.html2html.process_embedded_image'?: boolean;
    'advanced_setting.html2html.process_form'?: boolean;
    'advanced_setting.html2html.process_hyperlink_behavior'?: string;
    'advanced_setting.html2html.process_image'?: boolean;
    'advanced_setting.html2html.process_qrcode'?: boolean;
    'advanced_setting.html2html.process_text_link'?: boolean;
    'advanced_setting.html2html.process_zero_font_text'?: boolean;
    'advanced_setting.html2html.remove_applet'?: boolean;
    'advanced_setting.html2html.remove_comment'?: boolean;
    'advanced_setting.html2html.remove_comment.remove_conditional_comment'?: boolean;
    'advanced_setting.html2html.remove_iframe'?: boolean;
    'advanced_setting.html2html.remove_object'?: boolean;
    'advanced_setting.html2html.remove_script'?: boolean;
    'advanced_setting.html2html.remove_unapproved_tags'?: boolean;
    'advanced_setting.html2html.remove_unapproved_tags.approved_tags'?: string[];
    'advanced_setting.html2html.use_numeric_entity'?: boolean;
    'advanced_setting.hwp2hwp'?: boolean;
    'advanced_setting.hwp2hwp.hyperlink_prefix'?: string;
    'advanced_setting.hwp2hwp.process_chart'?: string;
    'advanced_setting.hwp2hwp.process_embedded_font'?: string;
    'advanced_setting.hwp2hwp.process_image'?: boolean;
    'advanced_setting.hwp2hwp.process_rtf'?: boolean;
    'advanced_setting.hwp2hwp.recursive_level'?: number;
    'advanced_setting.hwp2hwp.remove_embedded_object'?: boolean;
    'advanced_setting.hwp2hwp.remove_hyperlink'?: string;
    'advanced_setting.hwp2hwp.remove_macro'?: boolean;
    'advanced_setting.hwp2hwp.remove_metadata'?: boolean;
    'advanced_setting.ics2ics'?: boolean;
    'advanced_setting.ics2ics.hyperlink_prefix'?: string;
    'advanced_setting.ics2ics.process_hyperlink_behavior'?: string;
    'advanced_setting.ics2ics.remove_external_attachment'?: boolean;
    'advanced_setting.ics2ics.sanitize_inline_attachment'?: string;
    'advanced_setting.image'?: boolean;
    'advanced_setting.image.deep_sanitization'?: boolean;
    'advanced_setting.image.gif_layers_limit'?: number;
    'advanced_setting.image.image_quality'?: string;
    'advanced_setting.image.image_size_limit'?: number;
    'advanced_setting.image.preserve_geotiff_tags'?: boolean;
    'advanced_setting.image.remove_icc_profile'?: boolean;
    'advanced_setting.image.remove_metadata'?: boolean;
    'advanced_setting.image.restrict_big_tiff'?: boolean;
    'advanced_setting.image.restrict_big_tiff.restricted_size'?: number;
    'advanced_setting.image.sanitize_qrcode'?: boolean;
    'advanced_setting.image.sanitize_qrcode.applicable_file_types'?: string[];
    'advanced_setting.image.sanitize_qrcode.hyperlink_prefix'?: string;
    'advanced_setting.image.sanitize_qrcode.process_hyperlink_behavior'?: string;
    'advanced_setting.image.tiff_size_limit'?: number;
    'advanced_setting.image_conversion'?: boolean;
    'advanced_setting.image_conversion.bmp_output_size'?: any[];
    'advanced_setting.isg_excel'?: boolean;
    'advanced_setting.isg_excel.remove_image_metadata'?: boolean;
    'advanced_setting.isg_pdf'?: boolean;
    'advanced_setting.isg_pdf.remove_popup_annotation'?: boolean;
    'advanced_setting.isg_pdf.remove_text_annotation'?: boolean;
    'advanced_setting.isg_powerpoint'?: boolean;
    'advanced_setting.isg_powerpoint.remove_image_metadata'?: boolean;
    'advanced_setting.isg_word'?: boolean;
    'advanced_setting.isg_word.remove_field_code'?: boolean;
    'advanced_setting.isg_word.remove_image_metadata'?: boolean;
    'advanced_setting.json2json'?: boolean;
    'advanced_setting.json2json.preserve_format'?: boolean;
    'advanced_setting.json2json.process_base64'?: boolean;
    'advanced_setting.json2json.process_base64.action_on_unsanitized'?: string;
    'advanced_setting.json2json.process_base64.follow_data_schema'?: boolean;
    'advanced_setting.json2json.process_base64.json_path'?: string[];
    'advanced_setting.json2json.support_nd'?: boolean;
    'advanced_setting.jtd2jtd'?: boolean;
    'advanced_setting.jtd2jtd.process_image'?: boolean;
    'advanced_setting.jtd2jtd.remove_embedded_font'?: boolean;
    'advanced_setting.jtd2jtd.remove_embedded_object'?: boolean;
    'advanced_setting.jtd2jtd.remove_hyperlink'?: boolean;
    'advanced_setting.jtd2jtd.remove_macro'?: boolean;
    'advanced_setting.jww2jww'?: boolean;
    'advanced_setting.jww2jww.process_image'?: boolean;
    'advanced_setting.lnk2lnk'?: boolean;
    'advanced_setting.lnk2lnk.commands_to_remove'?: string;
    'advanced_setting.media_setting'?: boolean;
    'advanced_setting.media_setting.number_of_video_conversion_threads'?: number;
    'advanced_setting.media_setting.preferred_frame_rate'?: boolean;
    'advanced_setting.media_setting.preferred_frame_rate.frame_rate'?: number;
    'advanced_setting.mht2mht'?: boolean;
    'advanced_setting.mht2mht.remove_embedded_object'?: boolean;
    'advanced_setting.mp32mp3'?: boolean;
    'advanced_setting.mp32mp3.remove_metadata'?: boolean;
    'advanced_setting.mp32mp3.validate_audio_frame_data'?: boolean;
    'advanced_setting.mp32mp3.validate_audio_frame_data.invalid_data_occurrence_threshold'?: number;
    'advanced_setting.mpeg42mpeg4'?: boolean;
    'advanced_setting.mpeg42mpeg4.remove_metadata'?: boolean;
    'advanced_setting.mpeg42mpeg4.strict_validation'?: boolean;
    'advanced_setting.mpp2mpp'?: boolean;
    'advanced_setting.mpp2mpp.remove_embedded_object'?: boolean;
    'advanced_setting.mpp2mpp.remove_macro'?: boolean;
    'advanced_setting.mxf2mxf'?: boolean;
    'advanced_setting.mxf2mxf.strict_validation'?: boolean;
    'advanced_setting.odg2odg'?: boolean;
    'advanced_setting.odg2odg.hyperlink_prefix'?: string;
    'advanced_setting.odg2odg.process_image'?: boolean;
    'advanced_setting.odg2odg.recursive_level'?: number;
    'advanced_setting.odg2odg.remove_comment'?: boolean;
    'advanced_setting.odg2odg.remove_embedded_font'?: boolean;
    'advanced_setting.odg2odg.remove_embedded_object'?: boolean;
    'advanced_setting.odg2odg.remove_hyperlink'?: string;
    'advanced_setting.odg2odg.remove_macro'?: boolean;
    'advanced_setting.odg2odg.remove_metadata'?: boolean;
    'advanced_setting.odp2odp'?: boolean;
    'advanced_setting.odp2odp.hyperlink_prefix'?: string;
    'advanced_setting.odp2odp.process_image'?: boolean;
    'advanced_setting.odp2odp.recursive_level'?: number;
    'advanced_setting.odp2odp.remove_embedded_font'?: boolean;
    'advanced_setting.odp2odp.remove_embedded_object'?: boolean;
    'advanced_setting.odp2odp.remove_hyperlink'?: string;
    'advanced_setting.odp2odp.remove_macro'?: boolean;
    'advanced_setting.odp2odp.remove_metadata'?: boolean;
    'advanced_setting.ods2ods'?: boolean;
    'advanced_setting.ods2ods.hyperlink_prefix'?: string;
    'advanced_setting.ods2ods.process_image'?: boolean;
    'advanced_setting.ods2ods.recursive_level'?: number;
    'advanced_setting.ods2ods.remove_embedded_font'?: boolean;
    'advanced_setting.ods2ods.remove_embedded_object'?: boolean;
    'advanced_setting.ods2ods.remove_hyperlink'?: string;
    'advanced_setting.ods2ods.remove_macro'?: boolean;
    'advanced_setting.ods2ods.remove_metadata'?: boolean;
    'advanced_setting.odt2odt'?: boolean;
    'advanced_setting.odt2odt.hyperlink_prefix'?: string;
    'advanced_setting.odt2odt.process_image'?: boolean;
    'advanced_setting.odt2odt.recursive_level'?: number;
    'advanced_setting.odt2odt.remove_comment'?: boolean;
    'advanced_setting.odt2odt.remove_embedded_font'?: boolean;
    'advanced_setting.odt2odt.remove_embedded_object'?: boolean;
    'advanced_setting.odt2odt.remove_hidden_text'?: boolean;
    'advanced_setting.odt2odt.remove_hyperlink'?: string;
    'advanced_setting.odt2odt.remove_macro'?: boolean;
    'advanced_setting.odt2odt.remove_metadata'?: boolean;
    'advanced_setting.odt2odt.remove_revision'?: boolean;
    'advanced_setting.ogg2ogg'?: boolean;
    'advanced_setting.ogg2ogg.remove_metadata'?: boolean;
    'advanced_setting.ogg2ogg.strict_validation'?: boolean;
    'advanced_setting.one2one'?: boolean;
    'advanced_setting.one2one.hyperlink_prefix'?: string;
    'advanced_setting.one2one.process_image'?: boolean;
    'advanced_setting.one2one.remove_embedded_object'?: boolean;
    'advanced_setting.one2one.remove_hyperlink'?: string;
    'advanced_setting.p212p21'?: boolean;
    'advanced_setting.p212p21.remove_comment'?: boolean;
    'advanced_setting.pbix2pbix'?: boolean;
    'advanced_setting.pbix2pbix.cleanup_unused_resources'?: boolean;
    'advanced_setting.pbix2pbix.process_image'?: boolean;
    'advanced_setting.pdf2image'?: boolean;
    'advanced_setting.pdf2image.image_quality'?: string;
    'advanced_setting.pdf2pdf'?: boolean;
    'advanced_setting.pdf2pdf.convert_to_rasterized_pdf'?: boolean;
    'advanced_setting.pdf2pdf.display_hyperlinks_in_comments'?: boolean;
    'advanced_setting.pdf2pdf.hyperlink_prefix'?: string;
    'advanced_setting.pdf2pdf.image_quality'?: string;
    'advanced_setting.pdf2pdf.process_3d_object'?: boolean;
    'advanced_setting.pdf2pdf.process_image'?: boolean;
    'advanced_setting.pdf2pdf.process_image.process_qrcode'?: boolean;
    'advanced_setting.pdf2pdf.process_image.process_raw_image'?: boolean;
    'advanced_setting.pdf2pdf.process_postscript'?: boolean;
    'advanced_setting.pdf2pdf.recursive_level'?: number;
    'advanced_setting.pdf2pdf.remove_embedded_font'?: boolean;
    'advanced_setting.pdf2pdf.remove_embedded_object'?: boolean;
    'advanced_setting.pdf2pdf.remove_embedded_object.excluded_file_types'?: string;
    'advanced_setting.pdf2pdf.remove_form'?: boolean;
    'advanced_setting.pdf2pdf.remove_hyperlink'?: string;
    'advanced_setting.pdf2pdf.remove_macro'?: boolean;
    'advanced_setting.pdf2pdf.remove_metadata'?: boolean;
    'advanced_setting.pdf2pdf.remove_named_action'?: boolean;
    'advanced_setting.pdf2pdf.remove_named_action.allowed_named_actions'?: string[];
    'advanced_setting.pdf2pdf.remove_web_capture_content_db'?: boolean;
    'advanced_setting.pdf2pdf.skip_signed_file'?: boolean;
    'advanced_setting.pdf2pdf.skip_signed_file.skip_only_if_valid'?: boolean;
    'advanced_setting.pdf2pdf.strict_validation'?: boolean;
    'advanced_setting.pdf2pdf.validate_digital_signature'?: boolean;
    'advanced_setting.pdf2pdf.validate_digital_signature.validate_digital_certificate'?: boolean;
    'advanced_setting.pdf2pdf.validate_digital_signature.validate_digital_certificate.trusted_cas_dir'?: string;
    'advanced_setting.ppt*2ppt*'?: boolean;
    'advanced_setting.ppt*2ppt*.hyperlink_prefix'?: string;
    'advanced_setting.ppt*2ppt*.macro_hash'?: string[];
    'advanced_setting.ppt*2ppt*.process_image'?: boolean;
    'advanced_setting.ppt*2ppt*.process_image.allowlist_external_image'?: boolean;
    'advanced_setting.ppt*2ppt*.process_image.allowlist_pattern'?: string[];
    'advanced_setting.ppt*2ppt*.process_image.sanitize_qrcode'?: boolean;
    'advanced_setting.ppt*2ppt*.recursive_level'?: number;
    'advanced_setting.ppt*2ppt*.remove_chart'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_comment'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_custom_xml'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_embedded_font'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_embedded_object'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_hyperlink'?: string;
    'advanced_setting.ppt*2ppt*.remove_macro'?: string;
    'advanced_setting.ppt*2ppt*.remove_metadata'?: boolean;
    'advanced_setting.ppt*2ppt*.remove_smart_tag'?: boolean;
    'advanced_setting.ppt*2ppt*.skip_signed_file'?: boolean;
    'advanced_setting.ppt*2ppt*.skip_signed_macro'?: boolean;
    'advanced_setting.ppt*2ppt*.validate_document_properties'?: boolean;
    'advanced_setting.ppt*2ppt*.validate_document_properties.validation_effect'?: string;
    'advanced_setting.ppt*2ppt*.validate_structural_xml'?: boolean;
    'advanced_setting.ppt*2ppt*.validate_structural_xml.validation_effect'?: string;
    'advanced_setting.ppt*2ppt*.validate_zip_structure'?: boolean;
    'advanced_setting.ppt*2ppt*.validate_zip_structure.validation_effect'?: string;
    'advanced_setting.rtf2rtf'?: boolean;
    'advanced_setting.rtf2rtf.hyperlink_prefix'?: string;
    'advanced_setting.rtf2rtf.process_font_table'?: boolean;
    'advanced_setting.rtf2rtf.process_font_table.font_limit'?: number;
    'advanced_setting.rtf2rtf.process_image'?: boolean;
    'advanced_setting.rtf2rtf.recursive_level'?: number;
    'advanced_setting.rtf2rtf.remove_embedded_html'?: string;
    'advanced_setting.rtf2rtf.remove_embedded_object'?: boolean;
    'advanced_setting.rtf2rtf.remove_hyperlink'?: string;
    'advanced_setting.rtf2rtf.remove_metadata'?: boolean;
    'advanced_setting.setting'?: boolean;
    'advanced_setting.setting.analysis_mode'?: boolean;
    'advanced_setting.setting.deep_dive'?: boolean;
    'advanced_setting.setting.include_binary_objects'?: boolean;
    'advanced_setting.setting.include_binary_objects.object_size_limit'?: number;
    'advanced_setting.setting.include_processed_objects'?: boolean;
    'advanced_setting.setting.include_sanitization_details'?: boolean;
    'advanced_setting.setting.mark_categories_skip'?: boolean;
    'advanced_setting.setting.mark_categories_skip.categories'?: string[];
    'advanced_setting.setting.whitelist_hyperlink'?: boolean;
    'advanced_setting.setting.whitelist_pattern'?: string[];
    'advanced_setting.sfc2sfc'?: boolean;
    'advanced_setting.sfc2sfc.remove_comment'?: boolean;
    'advanced_setting.show2show'?: boolean;
    'advanced_setting.show2show.hyperlink_prefix'?: string;
    'advanced_setting.show2show.process_image'?: boolean;
    'advanced_setting.show2show.process_image.allowlist_external_image'?: boolean;
    'advanced_setting.show2show.process_image.allowlist_pattern'?: string[];
    'advanced_setting.show2show.process_image.sanitize_qrcode'?: boolean;
    'advanced_setting.show2show.recursive_level'?: number;
    'advanced_setting.show2show.remove_chart'?: boolean;
    'advanced_setting.show2show.remove_comment'?: boolean;
    'advanced_setting.show2show.remove_embedded_object'?: boolean;
    'advanced_setting.show2show.remove_hyperlink'?: string;
    'advanced_setting.show2show.remove_metadata'?: boolean;
    'advanced_setting.svg2svg'?: boolean;
    'advanced_setting.svg2svg.process_embedded_image'?: boolean;
    'advanced_setting.svg2svg.process_foreign_object'?: string;
    'advanced_setting.svg2svg.process_image'?: boolean;
    'advanced_setting.svg2svg.remove_cdata'?: boolean;
    'advanced_setting.svg2svg.remove_injection'?: boolean;
    'advanced_setting.svg2svg.remove_macro'?: boolean;
    'advanced_setting.twb2twb'?: boolean;
    'advanced_setting.twb2twb.hyperlink_prefix'?: string;
    'advanced_setting.twb2twb.process_hyperlink_behavior'?: string;
    'advanced_setting.twb2twb.remove_macro'?: boolean;
    'advanced_setting.twb2twb.remove_web_data_connection'?: boolean;
    'advanced_setting.txt2txt'?: boolean;
    'advanced_setting.txt2txt.hyperlink_prefix'?: string;
    'advanced_setting.txt2txt.preferred_encodings'?: string[];
    'advanced_setting.txt2txt.process_ascii_qr'?: boolean;
    'advanced_setting.txt2txt.remove_hyperlink'?: string;
    'advanced_setting.txt2txt.remove_invisible_text'?: boolean;
    'advanced_setting.txt2txt.remove_invisible_text.exceptional_characters'?: string[];
    'advanced_setting.txt2txt.remove_invisible_text.invisible_text_categories'?: string[];
    'advanced_setting.url2url'?: boolean;
    'advanced_setting.url2url.hyperlink_prefix'?: string;
    'advanced_setting.url2url.process_hyperlink_behavior'?: string;
    'advanced_setting.vcf2vcf'?: boolean;
    'advanced_setting.vcf2vcf.hyperlink_prefix'?: string;
    'advanced_setting.vcf2vcf.process_base64'?: boolean;
    'advanced_setting.vcf2vcf.process_base64.action_on_unsanitized'?: string;
    'advanced_setting.vcf2vcf.process_hyperlink_behavior'?: string;
    'advanced_setting.vsd*2vsd*'?: boolean;
    'advanced_setting.vsd*2vsd*.hyperlink_prefix'?: string;
    'advanced_setting.vsd*2vsd*.process_image'?: boolean;
    'advanced_setting.vsd*2vsd*.recursive_level'?: number;
    'advanced_setting.vsd*2vsd*.remove_embedded_object'?: boolean;
    'advanced_setting.vsd*2vsd*.remove_hyperlink'?: string;
    'advanced_setting.vsd*2vsd*.remove_macro'?: boolean;
    'advanced_setting.vsd*2vsd*.remove_metadata'?: boolean;
    'advanced_setting.vsix2vsix'?: boolean;
    'advanced_setting.vsix2vsix.process_image'?: boolean;
    'advanced_setting.vsix2vsix.process_tracked_files'?: boolean;
    'advanced_setting.vsix2vsix.process_untracked_files'?: boolean;
    'advanced_setting.vsix2vsix.process_untracked_files.supported_file_types'?: string[];
    'advanced_setting.vsix2vsix.validate_structural_file'?: boolean;
    'advanced_setting.vsix2vsix.validate_structural_file.validation_effect'?: string;
    'advanced_setting.wav2wav'?: boolean;
    'advanced_setting.wav2wav.remove_hidden_data'?: boolean;
    'advanced_setting.wav2wav.remove_metadata'?: boolean;
    'advanced_setting.wav2wav.signal_to_noise'?: number;
    'advanced_setting.wav2wav.strict_validation'?: boolean;
    'advanced_setting.webm2webm'?: boolean;
    'advanced_setting.webm2webm.strict_validation'?: boolean;
    'advanced_setting.wma2wma'?: boolean;
    'advanced_setting.wma2wma.remove_metadata'?: boolean;
    'advanced_setting.wmv2wmv'?: boolean;
    'advanced_setting.wmv2wmv.remove_metadata'?: boolean;
    'advanced_setting.xdw2xdw'?: boolean;
    'advanced_setting.xdw2xdw.hyperlink_prefix'?: string;
    'advanced_setting.xdw2xdw.process_hyperlink_behavior'?: string;
    'advanced_setting.xdw2xdw.remove_embedded_object'?: boolean;
    'advanced_setting.xdw2xdw.remove_image_annotation'?: boolean;
    'advanced_setting.xls*2xls*'?: boolean;
    'advanced_setting.xls*2xls*.cleanup_unused_resources'?: boolean;
    'advanced_setting.xls*2xls*.convert_to_rasterized_pdf'?: boolean;
    'advanced_setting.xls*2xls*.hyperlink_prefix'?: string;
    'advanced_setting.xls*2xls*.macro_hash'?: string[];
    'advanced_setting.xls*2xls*.process_image'?: boolean;
    'advanced_setting.xls*2xls*.process_image.allowlist_external_image'?: boolean;
    'advanced_setting.xls*2xls*.process_image.allowlist_pattern'?: string[];
    'advanced_setting.xls*2xls*.process_image.sanitize_qrcode'?: boolean;
    'advanced_setting.xls*2xls*.recursive_level'?: number;
    'advanced_setting.xls*2xls*.remove_comment'?: boolean;
    'advanced_setting.xls*2xls*.remove_custom_xml'?: boolean;
    'advanced_setting.xls*2xls*.remove_embedded_object'?: boolean;
    'advanced_setting.xls*2xls*.remove_external_content'?: boolean;
    'advanced_setting.xls*2xls*.remove_hyperlink'?: string;
    'advanced_setting.xls*2xls*.remove_macro'?: string;
    'advanced_setting.xls*2xls*.remove_metadata'?: boolean;
    'advanced_setting.xls*2xls*.remove_revision'?: boolean;
    'advanced_setting.xls*2xls*.remove_smart_tag'?: boolean;
    'advanced_setting.xls*2xls*.skip_signed_file'?: boolean;
    'advanced_setting.xls*2xls*.skip_signed_macro'?: boolean;
    'advanced_setting.xls*2xls*.validate_document_properties'?: boolean;
    'advanced_setting.xls*2xls*.validate_document_properties.validation_effect'?: string;
    'advanced_setting.xls*2xls*.validate_header_footer'?: boolean;
    'advanced_setting.xls*2xls*.validate_header_footer.validation_effect'?: string;
    'advanced_setting.xls*2xls*.validate_structural_xml'?: boolean;
    'advanced_setting.xls*2xls*.validate_structural_xml.validation_effect'?: string;
    'advanced_setting.xls*2xls*.validate_zip_structure'?: boolean;
    'advanced_setting.xls*2xls*.validate_zip_structure.validation_effect'?: string;
    'advanced_setting.xml2xml'?: boolean;
    'advanced_setting.xml2xml.enable_encoding_fallback'?: boolean;
    'advanced_setting.xml2xml.enable_encoding_fallback.fallback_encoding'?: string;
    'advanced_setting.xml2xml.process_base64'?: boolean;
    'advanced_setting.xml2xml.process_base64.action_on_unsanitized'?: string;
    'advanced_setting.xml2xml.process_base64.follow_data_schema'?: boolean;
    'advanced_setting.xml2xml.process_base64.xml_path'?: string[];
    'advanced_setting.xml2xml.remove_cdata'?: string;
    'advanced_setting.xml2xml.remove_injection'?: boolean;
    'advanced_setting.xml2xml.remove_macro'?: boolean;
    'advanced_setting.xml2xml.validate_against_schema'?: boolean;
    'advanced_setting.xml2xml.validate_against_schema.schema_location'?: string;
    'advanced_setting.xml2xml.validate_against_schema.schema_name'?: string;
    'advanced_setting.xml2xml.validate_against_schema.validation_effect'?: string;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface FiletypeConfig {
    filetype_timeout: number;
    filetype_fallback: boolean;
    'filetype_fallback.except_when_filetype_not_enabled_cdr': boolean;
    accept_non_standard_zip: boolean;
    block_files: string[];
    classify_with_ml: boolean;
    detect_base64: boolean;
    'detect_base64.minimum_size_base64': number;
    detect_encrypted_archive: boolean;
    distinguish_zero_byte_files: boolean;
    enable_ascii: boolean;
    'enable_ascii.non_printable_threshold': number;
    enable_shift_jis: boolean;
    filetype_mismatch: boolean;
    'filetype_mismatch.accepted_extensions': { extensions_to_apply: string }[];
    include_file_details: boolean;
    'include_file_details.file_metadata': boolean;
    'include_file_details.other_details': boolean;
    not_classify: string[] | { fileTypes: string; sub_filetype: string }[];
    'not_classify.fileTypes'?: string;
    'not_classify.sub_filetype'?: string;
    run_all_detections: boolean;
    specified_detection: boolean;
    'specified_detection.file_types': string[];
    'specified_detection.groups': string[];
    platform_enabled?: boolean;
    profile_id?: string;
}

interface FilescanioConfig {
    sandbox_timeout?: number;
    sandbox_retries?: number;
    max_file_size?: number;
    reputation_verdict_filter?: string[];
    av_verdict_filter?: AVResult[];
    ds_result_filter?: CDRResult[];
    generate_html_report?: boolean;
    generate_pdf_report?: boolean;
    analysis_timeout?: number;
    blocked_verdicts?: string[];
    custom_profile?: boolean;
    'custom_profile.early_termination'?: boolean;
    'custom_profile.input_file_yara'?: boolean;
    'custom_profile.certificates'?: boolean;
    'custom_profile.extracted_files_yara'?: boolean;
    'custom_profile.extract_strings'?: boolean;
    'custom_profile.hash_osint'?: boolean;
    'custom_profile.osint'?: boolean;
    'custom_profile.extracted_files_osint'?: boolean;
    'custom_profile.url_analysis'?: boolean;
    pre_defined_profile?: boolean;
    'pre_defined_profile.scan_profile'?: string;
    request_full_report?: boolean;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface OesisConfig {
    fbva_timeout: number;
    fbva_retries: number;
    severity_threshold: string;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface SbomConfig {
    sbom_retries: number;
    block_when_sbom_failed: boolean;
    container_timeout: number;
    dependency_detection: boolean;
    'dependency_detection.dependency_vuln_blocked': boolean;
    is_cyclonedx: boolean;
    is_spdx: boolean;
    license_feature: boolean;
    'license_feature.blocked_licenses': number[];
    severity_threshold: string;
    source_code_timeout: number;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface MetascanConfig {
    av_timeout: number;
    av_retries: number;
    suspicious_considered_as: string;
    infected_threshold: number;
    suspicious_threshold: number;
    failure_threshold: number;
    platform_enabled?: boolean;
    profile_id?: string;
    selected_avs?: string[];
}

export enum FileSizeUnit {
    MB = 0,
    KB = 1,
    B = 2,
}

export enum FileSizeOperator {
    LessThan = 0,
    GreaterThan = 1,
}

export interface FileGroupEntry {
    type: string;
    size_greater_than?: number;
    ignore_in_archive?: boolean;
}

export type FileGroupId = 'A' | 'AP' | 'D' | 'D_ENC' | 'E' | 'G' | 'I' | 'M' | 'O' | 'OPENSSL_ENC' | 'P' | 'T' | 'Z';

interface ListConfig {
    scan_allowlisted?: boolean;
    scan_blocklisted?: boolean;
    hash?: boolean;
    'hash.filters'?: string[];
    filegroup?: boolean;
    'filegroup.condition'?: number;
    'filegroup.A'?: FileGroupEntry[];
    'filegroup.AP'?: FileGroupEntry[];
    'filegroup.D'?: FileGroupEntry[];
    'filegroup.D_ENC'?: FileGroupEntry[];
    'filegroup.E'?: FileGroupEntry[];
    'filegroup.G'?: FileGroupEntry[];
    'filegroup.I'?: FileGroupEntry[];
    'filegroup.M'?: FileGroupEntry[];
    'filegroup.O'?: FileGroupEntry[];
    'filegroup.OPENSSL_ENC'?: FileGroupEntry[];
    'filegroup.P'?: FileGroupEntry[];
    'filegroup.T'?: FileGroupEntry[];
    'filegroup.Z'?: FileGroupEntry[];
    mimetype?: boolean;
    'mimetype.filters'?: Array<{ mime: string; size_greater_than?: number }>;
    exclude_mimetype?: boolean;
    'exclude_mimetype.filters'?: Array<{ mime: string; size_greater_than?: number }>;
    filename?: boolean;
    'filename.condition'?: number;
    'filename.filters'?: Array<{ name: string; size_greater_than?: number }>;
    filesize?: boolean;
    'filesize.operator'?: FileSizeOperator;
    'filesize.size'?: number;
    'filesize.unit'?: FileSizeUnit;
    platform_enabled?: boolean;
    profile_id?: string;
}

interface GeneralConfig {
    global_timeout?: number;
    download_timeout?: number;
    global_retries?: number;
    'webhook.enabled'?: boolean;
    'webhook.callback_url'?: string;
    'webhook.basic_authentication'?: string;
    max_file_size?: number;
    skip_generate_hash?: boolean;
    group_of_engine_progress?: string[];
    allow_scan_results?: Array<{ result_code: ScanResultCode; allowed: boolean }>;
    platform_enabled?: boolean;
    profile_id?: string;
}

export enum EngineType {
    Extraction = 'extraction',
    Aigcd = 'aigcd',
    Compression = 'compression',
    Coo = 'coo',
    Dlp = 'dlp',
    Cdr = 'cdr',
    Filetype = 'filetype',
    Filescanio = 'filescanio',
    Oesis = 'oesis',
    Sbom = 'sbom',
    Metascan = 'metascan',
    Allowlist = 'allowlist',
    Blocklist = 'blocklist',
    General = 'general',
}

export enum GateId {
    Zero = 0,
    One = 1,
    Two = 2,
    Three = 3,
}

export enum AVResult {
    Clean = 'clean',
    Infected = 'infected',
    Suspicious = 'suspicious',
    FailedToScan = 'failed_to_scan',
    NotScanned = 'not_scanned',
    PotentiallyUnwanted = 'potentially_unwanted',
}

export enum CDRResult {
    DSBlocked = 'ds_blocked',
    SanitizedOrPartially = 'sanitized_or_partially',
    SanitizationFailedOrTimedout = 'sanitization_failed_or_timedout',
    NotSanitized = 'not_sanitized',
    SanitizationSkipped = 'sanitization_skipped',
}

export enum ScanResultCode {
    NoThreatDetected = 0,
    Infected = 1,
    Suspicious = 2,
    Failed = 3,
    Whitelisted = 7,
    Blacklisted = 8,
    ExceededArchiveDepth = 9,
    NotScanned = 10,
    EncryptedArchive = 12,
    ExceededArchiveSize = 13,
    ExceededArchiveFileNumber = 14,
    PasswordProtectedDocument = 15,
    ExceededArchiveTimeout = 16,
    Mismatch = 17,
    PotentiallyVulnerableFile = 18,
    Cancelled = 19,
    SensitiveDataFound = 20,
    YaraRuleMatched = 21,
    PotentiallyUnwanted = 22,
    UnsupportedFileType = 23,
    ExtractionFailed = 24,
    ScanFailed = 25,
    SuspiciousSandbox = 26,
    LikelyMaliciousSandbox = 27,
    MaliciousSandbox = 28,
    BlockedSandbox = 29,
    BlockedDeepCDR = 30,
    GlobalTimeoutExceeded = 31,
    VulnerableSBOM = 32,
    NonVulnerableSBOM = 33,
    BlockedSBOM = 34,
    WeakVulnerableSBOM = 35,
    BlockedByPostAction = 36,
    KnownBad = 38,
    KnownGood = 39,
    Unknown = 40,
    AllowedCOO = 41,
    BlockedCOO = 42,
    UnknownCOO = 43,
    Exempted = 44,
    CompressionFailed = 45,
    InProgress = 255,
    SkipProcessingFastSymlink = 1014,
}

export interface WorkflowConfig {
    [EngineType.Extraction]?: Partial<ExtractionConfig>;
    [EngineType.Aigcd]?: Partial<AigcdConfig>;
    [EngineType.Compression]?: Partial<CompressionConfig>;
    [EngineType.Coo]?: Partial<CooConfig>;
    [EngineType.Dlp]?: Partial<DlpConfig>;
    [EngineType.Cdr]?: Partial<CdrConfig>;
    [EngineType.Filetype]?: Partial<FiletypeConfig>;
    [EngineType.Filescanio]?: Partial<FilescanioConfig>;
    [EngineType.Oesis]?: Partial<OesisConfig>;
    [EngineType.Sbom]?: Partial<SbomConfig>;
    [EngineType.Metascan]?: Partial<MetascanConfig>;
    [EngineType.Allowlist]?: Partial<ListConfig>;
    [EngineType.Blocklist]?: Partial<ListConfig>;
    [EngineType.General]?: Partial<GeneralConfig>;
}

export interface ProfileItem<T extends keyof WorkflowConfig = keyof WorkflowConfig> {
    initialData?: Omit<ProfileItem, 'initialData'>;
    _id?: string;
    name?: string;
    description?: string;
    engine_type?: T;
    configuration?: WorkflowConfig[T] & { group_of_engine_progress?: string[] };
    workflow_ids?: string[];
    status?: 'active' | 'inactive';
    created_at?: string;
    updated_at?: string;
}
